export default "__VITE_PUBLIC_ASSET__4319afd2__"